import React, {useState} from 'react';
import {Checkbox, DeprecatedCreativeModal as Modal, FlexRow, Label, Text, TextField} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';
import {UpdateSavedReportInput as SaveReportInput} from '../../../../../mutations/reporting/__generated__/updateSavedReportMutation.graphql';

type SaveReportModalProps = {
	saveReport: (report: SaveReportInput, closeModal: () => void) => void;
	report: SaveReportInput;
	closeModal: () => void;
};

const SaveReportModal = ({saveReport, report, closeModal}: SaveReportModalProps): React.JSX.Element => {
	const intl = useIntl();
	const [privateAccess, setPrivateAccess] = useState<boolean>(true);
	const [name, setName] = useState(report.name);

	const togglePrivateAccess = () => {
		setPrivateAccess(!privateAccess);
	};

	return (
		<Modal
			title={intl.formatMessage({id: 'saved_report.save_report'})}
			onCreateHandler={() => saveReport({...report, name, privateAccess}, closeModal)}
			creativeButtonText={intl.formatMessage({id: 'common.save'})}
			size="m"
			closeModal={closeModal}
			replicateDesignSystem
		>
			<TextField label="Report Name" value={name} onValueChange={setName} data-cy="report-name-input" />
			<Label>{intl.formatMessage({id: 'report.share-company-label'})}</Label>
			<FlexRow>
				<Checkbox checked={!privateAccess} onChange={togglePrivateAccess}></Checkbox>
				<Text>{intl.formatMessage({id: 'report.private_access.description'})}</Text>
			</FlexRow>
		</Modal>
	);
};

export default SaveReportModal;
